import React from "react";
import Slider from "react-slick";
import { Card, Container } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css";

const testimonials = [
  {
    quote:
      "Practical approach and continuous support helped me build a strong foundation in computer technologies.",
    name: "Nelson",
    title: "Software Engineer - Riverstone Infotech",
  },
  {
    quote:
      "Python lessons were taught really well which helped me understand the topics clearly.",
    name: "Benjamin Isaac",
    title: "Final Year BE (Mech), VIT",
  },
  {
    quote:
      "I have learnt a lot on problem solving. Thanks for your motivation and continuous guidance.",
    name: "Sathvika R",
    title: "Final Year BE(CS), KCG",
  },
  {
    quote:
      "Thank you for coaching me in competitive coding covering data structures and algorithms. Your training approach helped me practice faster.",
    name: "Abraham Niranjan I",
    title: "Software Engineer Trainee - TCS",
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="testimonial-section py-5">
      <Container>
        <h2 className="text-center mb-4">What Students Say</h2>

        <Slider {...settings}>
          {testimonials.map((item, index) => (
            <div key={index} className="px-3 d-flex">
              <Card className="testimonial-card text-center w-100">
                <Card.Body>
                  <div className="testimonial-quote">
                    <span className="quote-icon">“</span>
                    <p>{item.quote}</p>
                  </div>

                  <div className="testimonial-footer mt-3">
                    <h5 className="mb-1 fw-bold">{item.name}</h5>
                    <small className="text-muted">{item.title}</small>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default TestimonialSlider;